var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnnouncementGainIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 4C9.3832 4 4 9.3832 4 16C4 22.6168 9.3832 28 16 28C17.7592 28 19.5532 27.5548 21.3304 26.6752L20.2684 24.5236C18.8236 25.2376 17.3872 25.6 16 25.6C10.7068 25.6 6.4 21.2932 6.4 16C6.4 10.7068 10.7068 6.4 16 6.4C21.2932 6.4 25.6 10.7068 25.6 16V17.2C25.6 18.0304 25.2244 19.6 23.8 19.6C22.1248 19.6 22.0072 17.4172 22 17.2V11.2H19.6V11.23C18.5671 10.4367 17.3023 10.0046 16 10C12.6916 10 10 12.6916 10 16C10 19.3084 12.6916 22 16 22C17.74 22 19.2976 21.2428 20.3944 20.0548C21.0232 21.1228 22.084 22 23.8 22C26.5276 22 28 19.5268 28 17.2V16C28 9.3832 22.6168 4 16 4ZM16 19.6C14.0152 19.6 12.4 17.9848 12.4 16C12.4 14.0152 14.0152 12.4 16 12.4C17.9848 12.4 19.6 14.0152 19.6 16C19.6 17.9848 17.9848 19.6 16 19.6Z",
    fill: "#9142C5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncementGainIcon);
export default __webpack_public_path__ + "static/media/announcement-gain-icon.28992fa061a9e541797ff95e21cbe87e.svg";
export { ForwardRef as ReactComponent };